
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexcKnPPV_OdGNpz2VSQ3fwEqf2hxB6CYZtTWhCwQbu2zkMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/index.vue?macro=true";
import { default as indexo8QfblIaAoFp7HZZlTqf17alv4ankKIJYVyzjfblrbsMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/login/index.vue?macro=true";
import { default as set_45workspaceY3NnQsAOaNTjFj9_45cFMbZ7UUzBbWyXJxpWAYvy_45Y7yYMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/set-workspace.vue?macro=true";
import { default as indexty0J9kT16a8mKZaCtxnfg_o_gTYdmIiIOtgSxIP3PwMMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/sign-up/index.vue?macro=true";
import { default as indexRbzKcluzoNdO6EEHwa2BAWrL12mOIXX4Bqkg4yPNSScMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/magic-link/index.vue?macro=true";
import { default as index_zvFi9_yrY3CEZKbmmXzDPgQiZGBNh5ptP8aFVWTugcMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/index.vue?macro=true";
import { default as index3eYkOCHCuKnPHqqSKHJZNGLvNqdrik4jco77qnO3oowMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue?macro=true";
import { default as newIRQzrE_45GwHpyHYNXQKxtjdVuzNozV6mvqTvK0p7bXvkMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue?macro=true";
import { default as account_45configurationHb3nwf_6RtJ86LtR3BZA1jbEVbCdu2EZLIDV0IlKT78Meta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue?macro=true";
import { default as indexEcAnq3meN8ujCygxB_P7ibjhDh8iijGy35DS9hZJB0sMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue?macro=true";
import { default as mZHR7d_45VesDPCD_guli74K_SWKpon_45aSKvWvPqb1yORoMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m.vue?macro=true";
import { default as index2s47fvGNVXRvpt6LyK1DXkN7Ij3bSpMrceDysfYKUoAMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/reset-password/index.vue?macro=true";
import { default as indexaymwV5PDBSvLhWjGWjjWx9PYoF7wg2GYeL6BnL6HtQcMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/index.vue?macro=true";
import { default as indexfEkLcaQBAbeW9TWLnMTVu2Rl_45V8rVrQ0Ojr1HlsLN_4Meta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue?macro=true";
import { default as index5wm7BtSf7Di28nGv_45QuhwfnEryhrHDGS2svKCHRiIP0Meta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue?macro=true";
import { default as user_45signuprCi0WaanTGUw7c4oFCNrFDNuuW9x6EHaLQ5ZazR5pDoMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue?macro=true";
import { default as indexQm7nLnI9FRWPC1SXu8niK6uN0jISkJ5GDeCpQrti2w0Meta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue?macro=true";
import { default as indexw_45y_Lc0Fyi51FUHEUPHhNVAvP8JwIruUtZHvLooEskIMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue?macro=true";
import { default as indext__R2kAaAGMJJZ1tTgeVEANOqiSB7el8ZeNcCtVCUDMMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue?macro=true";
import { default as newVoDahT3XI5B2n4UGGnu53cFrX8jNxRWTYX7xoXupvOMMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue?macro=true";
import { default as _91id_93XZTcOcEjON58AoI8F49m6NQkRzo4abmm8LhNKKCGINAMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue?macro=true";
import { default as indexK_458_uAhU56GwxW5M2LNsPwRNHElFQxtplg6HIRPyTwIMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue?macro=true";
import { default as indexkeX1oqo43Y9fytusjbaM3pRSNacy3qZ43_45OJE2BlLV0Meta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue?macro=true";
import { default as index2rv4_45njH5i3T5pcQGy9x9jj6c4zwFkwN74CR9Zci5gIMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue?macro=true";
import { default as indexhFboOCuMKzRW_45S337jfrAV4NVCau5CGrOD0QWBoGycEMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue?macro=true";
import { default as indexNcio1ExiGbX6JhjfTXuOAPFNesLuePpvle9T9jbBCykMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue?macro=true";
import { default as indexjD45_45dim_fgoO6pBPvgxNRWjIVmR08_ZTOKv9Ihq_sQMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue?macro=true";
import { default as indexrNKUPu1pyPrQ0yLiodZxlkD3l3keK3AjsE89J0rLN_45EMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue?macro=true";
import { default as _91providerSlug_93vDG68brliM3gkwfxPNraUKbpHEc7NKkp94MKa6E3Z3oMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue?macro=true";
import { default as index937GhqnBE_45CZBKwzQkDxBlQwyzMUK_45gf15xxbneq8doMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue?macro=true";
import { default as settingsch_45BgelCeKvn662gzLbo5_45nMCWX1nvRTHLdutCZAk_45QMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue?macro=true";
import { default as indexWlpkcocMz12SLicACB_45o2ZU7lHmldYWjLl4dOYIRPAAMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue?macro=true";
import { default as _91id_93_45yISGSIVnBEGpP2YiQXEWROuM7G6ZMyI2UJkiHq8yMEMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue?macro=true";
import { default as indexpurGjHuFe_45LAL_45oVYhGDYl6VnYhYb6XPrhmfRYByU5QMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue?macro=true";
import { default as index8kEiHvDsLd71Jkg4fITCxu4u6wb__nybuaYm331T8UAMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue?macro=true";
import { default as importVVTHCCHbnwBurklZuL1eE5Ds0590hhPRFMTuRNCBmvcMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue?macro=true";
import { default as schemaXdyw99Cqd0ezCJwsFawppt0yicWpVReeNdr67eyWS2kMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue?macro=true";
import { default as indexilpi4dA_pIh89tTM6E8ONdZIrCIzU9Cl8T8wctCCEZAMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue?macro=true";
import { default as indexJyp7B26k3_hEFo7pLY8JcBPpWo1Pd5ZHT4NaxdvwK0IMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue?macro=true";
import { default as historypdZN1GOowXdCE8rH_YjZO8jA_gi5mUqt0gIVZN1kt5IMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue?macro=true";
import { default as studiobaJ_45zOOiDBV2cBGovQuRpt745APreYW7c4nZPGaGQ_YMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio.vue?macro=true";
import { default as indexKtWne2F61SgKvupnuKMOntW7e_4QVzFefNt8SEY8stgMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/p/index.vue?macro=true";
import { default as indexgBnGYpx2JeLTz4z9_UsHXDfbysOeg6SKqATcui7A4BEMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue?macro=true";
import { default as index0N_6kJG5wsUHZKP2SjfmlSPAReMr8Wt_VxaORYTYaLUMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/login/index.vue?macro=true";
import { default as indexX6cl_45093LFA28Xx_45oMoaYMTAcZuXjacZTfBFQTN31jIMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/store/index.vue?macro=true";
import { default as _91app_93T94mc5GWIab78vE7ld1gypHwhYr_cwVkKQDII8kXJ7EMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue?macro=true";
import { default as indexC54h5wFCfuFutIdo0AbG6U_h3hUZznXwlNNT_VMkf78Meta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue?macro=true";
import { default as index5wkuviqvKfeGUPm_45hw4RGqmhs_s7tWbvaV6KI9iucn0Meta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue?macro=true";
import { default as reset_45passwordlANXRJmouyO6NeXBdaWmAWEcGU7GaBa0OcV3j1EZsAUMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue?macro=true";
import { default as index14kAfravWqy_9EEkuVOPo76ZhuZ_45RSid_45DP3lObl0KoMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue?macro=true";
import { default as index0jcbt_45y4EJlFXgCzY5LzYJDKRny2xfrWtff5M0mhr6YMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue?macro=true";
import { default as indexSNotb2UVwZ9ZlzQzbGSTOFPmHBA1tZfA9gwRmhiBMnEMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue?macro=true";
import { default as _91appName_93o0u1yISA49c21zGjWPi4gU8tc3GFtFriSGJD6hrQ3ukMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue?macro=true";
import { default as indexWKluwkJnAuNDZl1vHVwn43GqFyWDNfqEl6gpMBI0kvkMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue?macro=true";
import { default as index_451qzxfaLZu9jAztpNvNXeenPEMVGk_R2zbhJRb_nNHoMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue?macro=true";
import { default as index88rJJbkY629n9pBOTxdMjWcViskgcwHyFV0Jft1AKnAMeta } from "/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    meta: indexcKnPPV_OdGNpz2VSQ3fwEqf2hxB6CYZtTWhCwQbu2zkMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/",
    meta: indexcKnPPV_OdGNpz2VSQ3fwEqf2hxB6CYZtTWhCwQbu2zkMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "login___pt",
    path: "/login",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/login/index.vue")
  },
  {
    name: "set-workspace___en",
    path: "/en/set-workspace",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "set-workspace___pt",
    path: "/set-workspace",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/set-workspace.vue")
  },
  {
    name: "sign-up___en",
    path: "/en/sign-up",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "sign-up___pt",
    path: "/sign-up",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/sign-up/index.vue")
  },
  {
    name: "magic-link___en",
    path: "/en/magic-link",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: "magic-link___pt",
    path: "/magic-link",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/magic-link/index.vue")
  },
  {
    name: mZHR7d_45VesDPCD_guli74K_SWKpon_45aSKvWvPqb1yORoMeta?.name,
    path: "/en/t/:tenantSlug()/m",
    meta: mZHR7d_45VesDPCD_guli74K_SWKpon_45aSKvWvPqb1yORoMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___en",
    path: "",
    meta: index_zvFi9_yrY3CEZKbmmXzDPgQiZGBNh5ptP8aFVWTugcMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___en",
    path: ":viewId()",
    meta: index3eYkOCHCuKnPHqqSKHJZNGLvNqdrik4jco77qnO3oowMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___en",
    path: ":viewId()/r/new",
    meta: newIRQzrE_45GwHpyHYNXQKxtjdVuzNozV6mvqTvK0p7bXvkMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___en",
    path: "account-configuration",
    meta: account_45configurationHb3nwf_6RtJ86LtR3BZA1jbEVbCdu2EZLIDV0IlKT78Meta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___en",
    path: ":viewId()/r/:recordId()",
    meta: indexEcAnq3meN8ujCygxB_P7ibjhDh8iijGy35DS9hZJB0sMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: mZHR7d_45VesDPCD_guli74K_SWKpon_45aSKvWvPqb1yORoMeta?.name,
    path: "/t/:tenantSlug()/m",
    meta: mZHR7d_45VesDPCD_guli74K_SWKpon_45aSKvWvPqb1yORoMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m.vue"),
    children: [
  {
    name: "t-tenantSlug-m___pt",
    path: "",
    meta: index_zvFi9_yrY3CEZKbmmXzDPgQiZGBNh5ptP8aFVWTugcMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId___pt",
    path: ":viewId()",
    meta: index3eYkOCHCuKnPHqqSKHJZNGLvNqdrik4jco77qnO3oowMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-new___pt",
    path: ":viewId()/r/new",
    meta: newIRQzrE_45GwHpyHYNXQKxtjdVuzNozV6mvqTvK0p7bXvkMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/new.vue")
  },
  {
    name: "t-tenantSlug-m-account-configuration___pt",
    path: "account-configuration",
    meta: account_45configurationHb3nwf_6RtJ86LtR3BZA1jbEVbCdu2EZLIDV0IlKT78Meta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/account-configuration.vue")
  },
  {
    name: "t-tenantSlug-m-viewId-r-recordId___pt",
    path: ":viewId()/r/:recordId()",
    meta: indexEcAnq3meN8ujCygxB_P7ibjhDh8iijGy35DS9hZJB0sMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/m/[viewId]/r/[recordId]/index.vue")
  }
]
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "reset-password___pt",
    path: "/reset-password",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/reset-password/index.vue")
  },
  {
    name: "t-tenantSlug___en",
    path: "/en/t/:tenantSlug()",
    meta: indexaymwV5PDBSvLhWjGWjjWx9PYoF7wg2GYeL6BnL6HtQcMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: "t-tenantSlug___pt",
    path: "/t/:tenantSlug()",
    meta: indexaymwV5PDBSvLhWjGWjjWx9PYoF7wg2GYeL6BnL6HtQcMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/index.vue")
  },
  {
    name: studiobaJ_45zOOiDBV2cBGovQuRpt745APreYW7c4nZPGaGQ_YMeta?.name,
    path: "/en/t/:tenantSlug()/studio",
    meta: studiobaJ_45zOOiDBV2cBGovQuRpt745APreYW7c4nZPGaGQ_YMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___en",
    path: "",
    meta: indexfEkLcaQBAbeW9TWLnMTVu2Rl_45V8rVrQ0Ojr1HlsLN_4Meta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsch_45BgelCeKvn662gzLbo5_45nMCWX1nvRTHLdutCZAk_45QMeta?.name,
    path: "settings",
    meta: settingsch_45BgelCeKvn662gzLbo5_45nMCWX1nvRTHLdutCZAk_45QMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___en",
    path: "",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___en",
    path: "user-signup",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___en",
    path: "users",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___en",
    path: "tokens",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___en",
    path: "internal",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___en",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___en",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___en",
    path: "app-builder",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___en",
    path: "export-data",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___en",
    path: "user-groups",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___en",
    path: "integrations",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___en",
    path: "authentication",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___en",
    path: "email-analytics",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___en",
    path: "system-entities",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___en",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___en",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___en",
    path: "data",
    meta: indexWlpkcocMz12SLicACB_45o2ZU7lHmldYWjLl4dOYIRPAAMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___en",
    path: "pages/:id()",
    meta: _91id_93_45yISGSIVnBEGpP2YiQXEWROuM7G6ZMyI2UJkiHq8yMEMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___en",
    path: "pages",
    meta: indexpurGjHuFe_45LAL_45oVYhGDYl6VnYhYb6XPrhmfRYByU5QMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___en",
    path: "data/:id()",
    meta: index8kEiHvDsLd71Jkg4fITCxu4u6wb__nybuaYm331T8UAMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___en",
    path: "data/:id()/import",
    meta: importVVTHCCHbnwBurklZuL1eE5Ds0590hhPRFMTuRNCBmvcMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___en",
    path: "data/:id()/schema",
    meta: schemaXdyw99Cqd0ezCJwsFawppt0yicWpVReeNdr67eyWS2kMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___en",
    path: "automations",
    meta: indexilpi4dA_pIh89tTM6E8ONdZIrCIzU9Cl8T8wctCCEZAMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___en",
    path: "automations/:id()",
    meta: indexJyp7B26k3_hEFo7pLY8JcBPpWo1Pd5ZHT4NaxdvwK0IMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___en",
    path: "automations/:id()/history",
    meta: historypdZN1GOowXdCE8rH_YjZO8jA_gi5mUqt0gIVZN1kt5IMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: studiobaJ_45zOOiDBV2cBGovQuRpt745APreYW7c4nZPGaGQ_YMeta?.name,
    path: "/t/:tenantSlug()/studio",
    meta: studiobaJ_45zOOiDBV2cBGovQuRpt745APreYW7c4nZPGaGQ_YMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio.vue"),
    children: [
  {
    name: "t-tenantSlug-studio___pt",
    path: "",
    meta: indexfEkLcaQBAbeW9TWLnMTVu2Rl_45V8rVrQ0Ojr1HlsLN_4Meta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/index.vue")
  },
  {
    name: settingsch_45BgelCeKvn662gzLbo5_45nMCWX1nvRTHLdutCZAk_45QMeta?.name,
    path: "settings",
    meta: settingsch_45BgelCeKvn662gzLbo5_45nMCWX1nvRTHLdutCZAk_45QMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings.vue"),
    children: [
  {
    name: "t-tenantSlug-studio-settings___pt",
    path: "",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-signup___pt",
    path: "user-signup",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-signup.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-users___pt",
    path: "users",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/users/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-tokens___pt",
    path: "tokens",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/tokens/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-internal___pt",
    path: "internal",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/internal/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-new___pt",
    path: "user-groups/new",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/new.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups-id___pt",
    path: "user-groups/:id()",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-app-builder___pt",
    path: "app-builder",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/app-builder/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-export-data___pt",
    path: "export-data",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/export-data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-user-groups___pt",
    path: "user-groups",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/user-groups/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations___pt",
    path: "integrations",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-authentication___pt",
    path: "authentication",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/authentication/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-email-analytics___pt",
    path: "email-analytics",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/email-analytics/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-system-entities___pt",
    path: "system-entities",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/system-entities/index.vue")
  },
  {
    name: "t-tenantSlug-studio-settings-integrations-providerSlug___pt",
    path: "integrations/:providerSlug()",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/integrations/[providerSlug].vue")
  },
  {
    name: "t-tenantSlug-studio-settings-global-parameters-manager___pt",
    path: "global-parameters-manager",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/settings/global-parameters-manager/index.vue")
  }
]
  },
  {
    name: "t-tenantSlug-studio-data___pt",
    path: "data",
    meta: indexWlpkcocMz12SLicACB_45o2ZU7lHmldYWjLl4dOYIRPAAMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/index.vue")
  },
  {
    name: "t-tenantSlug-studio-pages-id___pt",
    path: "pages/:id()",
    meta: _91id_93_45yISGSIVnBEGpP2YiQXEWROuM7G6ZMyI2UJkiHq8yMEMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/pages/[id].vue")
  },
  {
    name: "t-tenantSlug-studio-pages___pt",
    path: "pages",
    meta: indexpurGjHuFe_45LAL_45oVYhGDYl6VnYhYb6XPrhmfRYByU5QMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/pages/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id___pt",
    path: "data/:id()",
    meta: index8kEiHvDsLd71Jkg4fITCxu4u6wb__nybuaYm331T8UAMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-import___pt",
    path: "data/:id()/import",
    meta: importVVTHCCHbnwBurklZuL1eE5Ds0590hhPRFMTuRNCBmvcMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/import.vue")
  },
  {
    name: "t-tenantSlug-studio-data-id-schema___pt",
    path: "data/:id()/schema",
    meta: schemaXdyw99Cqd0ezCJwsFawppt0yicWpVReeNdr67eyWS2kMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/data/[id]/schema.vue")
  },
  {
    name: "t-tenantSlug-studio-automations___pt",
    path: "automations",
    meta: indexilpi4dA_pIh89tTM6E8ONdZIrCIzU9Cl8T8wctCCEZAMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/automations/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id___pt",
    path: "automations/:id()",
    meta: indexJyp7B26k3_hEFo7pLY8JcBPpWo1Pd5ZHT4NaxdvwK0IMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/index.vue")
  },
  {
    name: "t-tenantSlug-studio-automations-id-history___pt",
    path: "automations/:id()/history",
    meta: historypdZN1GOowXdCE8rH_YjZO8jA_gi5mUqt0gIVZN1kt5IMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/studio/automations/[id]/history.vue")
  }
]
  },
  {
    name: "t-tenantSlug-p___en",
    path: "/en/t/:tenantSlug()/p",
    meta: indexKtWne2F61SgKvupnuKMOntW7e_4QVzFefNt8SEY8stgMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-p___pt",
    path: "/t/:tenantSlug()/p",
    meta: indexKtWne2F61SgKvupnuKMOntW7e_4QVzFefNt8SEY8stgMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/p/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___en",
    path: "/en/t/:tenantSlug()/mfa",
    meta: indexgBnGYpx2JeLTz4z9_UsHXDfbysOeg6SKqATcui7A4BEMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-mfa___pt",
    path: "/t/:tenantSlug()/mfa",
    meta: indexgBnGYpx2JeLTz4z9_UsHXDfbysOeg6SKqATcui7A4BEMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/mfa/index.vue")
  },
  {
    name: "t-tenantSlug-login___en",
    path: "/en/t/:tenantSlug()/login",
    meta: index0N_6kJG5wsUHZKP2SjfmlSPAReMr8Wt_VxaORYTYaLUMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-login___pt",
    path: "/t/:tenantSlug()/login",
    meta: index0N_6kJG5wsUHZKP2SjfmlSPAReMr8Wt_VxaORYTYaLUMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/login/index.vue")
  },
  {
    name: "t-tenantSlug-store___en",
    path: "/en/t/:tenantSlug()/store",
    meta: indexX6cl_45093LFA28Xx_45oMoaYMTAcZuXjacZTfBFQTN31jIMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-store___pt",
    path: "/t/:tenantSlug()/store",
    meta: indexX6cl_45093LFA28Xx_45oMoaYMTAcZuXjacZTfBFQTN31jIMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/store/index.vue")
  },
  {
    name: "t-tenantSlug-install-app___en",
    path: "/en/t/:tenantSlug()/install/:app()",
    meta: _91app_93T94mc5GWIab78vE7ld1gypHwhYr_cwVkKQDII8kXJ7EMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-install-app___pt",
    path: "/t/:tenantSlug()/install/:app()",
    meta: _91app_93T94mc5GWIab78vE7ld1gypHwhYr_cwVkKQDII8kXJ7EMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/install/[app].vue")
  },
  {
    name: "t-tenantSlug-loading___en",
    path: "/en/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-loading___pt",
    path: "/t/:tenantSlug()/loading",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/loading/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___en",
    path: "/en/t/:tenantSlug()/sign-up",
    meta: index5wkuviqvKfeGUPm_45hw4RGqmhs_s7tWbvaV6KI9iucn0Meta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-sign-up___pt",
    path: "/t/:tenantSlug()/sign-up",
    meta: index5wkuviqvKfeGUPm_45hw4RGqmhs_s7tWbvaV6KI9iucn0Meta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/sign-up/index.vue")
  },
  {
    name: "t-tenantSlug-reset-password___en",
    path: "/en/t/:tenantSlug()/reset-password",
    meta: reset_45passwordlANXRJmouyO6NeXBdaWmAWEcGU7GaBa0OcV3j1EZsAUMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-reset-password___pt",
    path: "/t/:tenantSlug()/reset-password",
    meta: reset_45passwordlANXRJmouyO6NeXBdaWmAWEcGU7GaBa0OcV3j1EZsAUMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/reset-password.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___en",
    path: "/en/t/:tenantSlug()/sso/saml",
    meta: index14kAfravWqy_9EEkuVOPo76ZhuZ_45RSid_45DP3lObl0KoMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-sso-saml___pt",
    path: "/t/:tenantSlug()/sso/saml",
    meta: index14kAfravWqy_9EEkuVOPo76ZhuZ_45RSid_45DP3lObl0KoMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/sso/saml/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___en",
    path: "/en/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-mfa-setup___pt",
    path: "/t/:tenantSlug()/mfa/setup",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/mfa/setup/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()",
    meta: indexSNotb2UVwZ9ZlzQzbGSTOFPmHBA1tZfA9gwRmhiBMnEMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId___pt",
    path: "/t/:tenantSlug()/p/:viewId()",
    meta: indexSNotb2UVwZ9ZlzQzbGSTOFPmHBA1tZfA9gwRmhiBMnEMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/index.vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___en",
    path: "/en/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93o0u1yISA49c21zGjWPi4gU8tc3GFtFriSGJD6hrQ3ukMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-store-apps-appName___pt",
    path: "/t/:tenantSlug()/store/apps/:appName()",
    meta: _91appName_93o0u1yISA49c21zGjWPi4gU8tc3GFtFriSGJD6hrQ3ukMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/store/apps/[appName].vue")
  },
  {
    name: "t-tenantSlug-install--review___en",
    path: "/en/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-install--review___pt",
    path: "/t/:tenantSlug()/install/-review",
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/install/-review/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___en",
    path: "/en/t/:tenantSlug()/email-validation",
    meta: index_451qzxfaLZu9jAztpNvNXeenPEMVGk_R2zbhJRb_nNHoMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-email-validation___pt",
    path: "/t/:tenantSlug()/email-validation",
    meta: index_451qzxfaLZu9jAztpNvNXeenPEMVGk_R2zbhJRb_nNHoMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/email-validation/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___en",
    path: "/en/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: index88rJJbkY629n9pBOTxdMjWcViskgcwHyFV0Jft1AKnAMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  },
  {
    name: "t-tenantSlug-p-viewId-r-recordId___pt",
    path: "/t/:tenantSlug()/p/:viewId()/r/:recordId()",
    meta: index88rJJbkY629n9pBOTxdMjWcViskgcwHyFV0Jft1AKnAMeta || {},
    component: () => import("/codebuild/output/src648158983/src/zazos-web/pages/t/[tenantSlug]/p/[viewId]/r/[recordId]/index.vue")
  }
]